import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import { AuthService } from '../auth/auth.service';
import * as FileSaver from "file-saver";

@Injectable()
export class AccountsService {

  private selectAccountManager: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public selectAccount: Observable<any>;

  private createAccountManager: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public createAccount: Observable<any>;

  private bulkCreateAccountManager: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public bulkCreateAccount: Observable<any>;

  private deleteAccountManager: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public deleteAccount: Observable<any>;

  private editAccountManager: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public editAccount: Observable<any>;

  private editFieldValueManager: ReplaySubject<any> = new ReplaySubject<any>(null);
  public editFieldValue: Observable<any>;

  public selectedAccount: any;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.selectAccount = this.selectAccountManager.asObservable();
    this.createAccount = this.createAccountManager.asObservable();
    this.bulkCreateAccount = this.bulkCreateAccountManager.asObservable();
    this.deleteAccount = this.deleteAccountManager.asObservable();
    this.editAccount = this.editAccountManager.asObservable();
    this.editFieldValue = this.editFieldValueManager.asObservable();

    this.authService.logOut.subscribe((doLogout) => {
      if (doLogout) {
        this.selectAccountManager.next(null);
      }
    });
  }

  list() {
    return this.http.get('/api/accounts');
  }

  async export() {
    let promise = await (new Promise((resolve, reject) => {
      try {
        this.http.get('/api/accounts/exports/xlsx', {
          headers: new HttpHeaders({
            'Content-type': 'application/xlsx'
          }),
          responseType: 'blob' as 'json',
          observe: 'response',
          withCredentials: true
        }
        ).subscribe((data:any ) => {
          const fileName = data.headers.get('Content-disposition').split('=')[1];
          const blob = new Blob([data.body], { type: 'application/xlsx' });
          FileSaver.saveAs(blob, fileName);
          resolve(true);
        })
      } catch (err) {
        reject(false);
      }
    }));
  }
  
  listWithCheckins() {
    return this.http.get('/api/accounts/checkins');
  }

  get(id) {
    return this.http.get(`/api/accounts/${id}`);
  }

  create(data) {
    return this.http.post('/api/accounts', data)
      .do((newAccount: any) => {
        this.createAccountManager.next(newAccount);
      });
  }

  bulkCreate(data) {
    return this.http.post('/api/accounts/bulk', data)
      .do((newAccounts: any) => {
        this.bulkCreateAccountManager.next(newAccounts);
      });
  }

  delete(id) {
    return this.http.delete(`/api/accounts/${id}`)
      .do(() => {
        this.deleteAccountManager.next(id);
      });
  }

  bulkDelete(ids) {
    ids.forEach(id => this.delete(id).subscribe());
  }

  edit(id, data) {
    return this.http.put(`/api/accounts/${id}`, data);
  }

  editCustomField(id, data) {
    return this.http.put(`/api/accounts/${id}/fields`, data)
      .do((res) => {
        this.editFieldValueManager.next(res);
      });
  }

  bulkEditCustomFields(ids, fieldValues) {
    return this.http.put(`api/accounts/${ids.join('&&')}/fields/mass`, fieldValues);
  }

  select(account) {
    this.selectedAccount = account;
    this.selectAccountManager.next(account);
  }

}



// WEBPACK FOOTER //
// ./client/app/core/accounts/accounts.service.ts